import React, { useState } from 'react';
import { faGithub, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';
import Perfil1 from "../../assets/perfil1.jpg";
import './style.css';

export default function Navbar() {

    const [showLinks, setShowLinks] = useState(false);

    return (
        <div className="navbar-container">
            <div id="navbar">
                <header>
                    <NavLink exact to="/" className="nav-link" onClick={() => setShowLinks(false)}><img src={Perfil1} alt="perfil1.png" /></NavLink>
                    
                    <h1>Jefferson Santos</h1>
                    <h3>Professor Curso Técnico em Desenvolvimento de Sistemas | Desenvolvedor Front-End | Analista de Suporte de TI | Empreendedor </h3>
                    <p>Formado em Ciência da Computação pela Faculdade Anhanguera Educacional</p>
                </header>
                <nav className="media">
                    <a href="https://github.com/jefferson-s" target="new">
                        <i><FontAwesomeIcon icon={faGithub}/></i>
                    </a>
                    <a href="https://www.instagram.com/jefferson.kdj/" target="new">
                        <i><FontAwesomeIcon icon={faInstagram}/></i>
                    </a>
                    <a href="https://www.linkedin.com/in/jefferson-dos-santos-907925182/" target="new">
                        <i><FontAwesomeIcon icon={faLinkedinIn}/></i>
                    </a>
                </nav>

                <FontAwesomeIcon
                    icon={showLinks ? faTimes : faBars }
                    id="icon"
                    onClick={() => setShowLinks(!showLinks)}
                />

                <nav className="navlinks" id={showLinks ? "hidden" : "" }>
                    <NavLink exact to="/" className="nav-link" onClick={() => setShowLinks(false)}>Início</NavLink>
                    <NavLink to="/about" className="nav-link" onClick={() => setShowLinks(false)}>Sobre mim</NavLink>
                    <NavLink to="/experiences" className="nav-link" onClick={() => setShowLinks(false)}>Experiência Profissional</NavLink>
                    <NavLink to="/skills" className="nav-link" onClick={() => setShowLinks(false)}>{`Cursos & Skills`}</NavLink>
                    <NavLink to="/projects" className="nav-link" onClick={() => setShowLinks(false)}>{`Projetos`}</NavLink>
                    <NavLink to="/contacts" className="nav-link" onClick={() => setShowLinks(false)}>Contatos</NavLink>
                </nav>
            </div>
        </div>
    );
}